import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_arrow_rig_gray",
  "use": "icon-icon_arrow_rig_gray-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-icon_arrow_rig_gray\"><path d=\"M4.862 1.869c.26-.26.682-.26.943 0l5.657 5.656a.664.664 0 0 1 .187.37l.008.102c0 .17-.065.341-.195.471l-5.657 5.657a.667.667 0 1 1-.943-.943l5.186-5.185-5.186-5.186a.667.667 0 0 1 0-.942Z\" fill=\"#B6BABF\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol